<template>
  <div>
    <v-card :ripple="false" :elevation="12" :max-width="this.cardMaxWidth">
      <template v-if="this.unitName === 'Output'">
        <CardTitle :name="this.cardName" colorProp="red darken-2" icon="mdi-lightbulb-on" />
      </template>

      <template v-if="this.unitName === 'Inverter'">
        <CardTitle :name="this.cardName" colorProp="blue-grey darken-2" icon="mdi-power" />
      </template>

      <template v-if="this.unitName === 'Grid'">
        <CardTitle :name="this.cardName" colorProp="purple darken-2" icon="mdi-power-plug" />
      </template>

      <template v-if="this.unitName === 'GridImport'">
        <CardTitle :name="this.cardName" colorProp="blue darken-2" icon="mdi-flash" />
      </template>

      <template v-if="this.unitName === 'Battery'">
        <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'light-green darken-2'" icon="mdi-battery" />
      </template>

      <template v-if="this.unitName === 'PV'">
        <CardTitle :name="this.cardName" colorProp="yellow darken-2" icon="mdi-white-balance-sunny" />
      </template>

      <template v-else>
        <template v-if="this.unitName === 'sun'">
          <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'amber'" icon="mdi-weather-sunny" />
        </template>

        <template v-if="this.unitName === 'wind'">
          <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'cyan'" icon="mdi-weather-windy-variant" />
        </template>
      </template>

      <v-card-text class="caption">
        <br />
        <br />

        <v-row class="text-left">
          <v-col cols="6">
            <div>
              <br />

              <v-carousel v-model="carousel" :light="!$vuetify.theme.dark" :dark="$vuetify.theme.dark" height="auto" cycle interval="10000" :show-arrows="false" hide-delimiter-background hide-delimiters>
                <div class="text-caption">
                  <v-carousel-item>
                    {{ this.energyHeader1 }}
                    <br />
                    <template v-if="this.energy1Text !== ''">
                      {{ this.energy1Text }}:
                      {{ this.energy1Value }}
                      kWh
                    </template>
                    <br />
                    <template v-if="this.energy2Text !== ''">
                      {{ this.energy2Text }}: {{ this.energy2Value }} kWh
                      <br />
                    </template>
                    <template v-else>
                      <br />
                    </template>
                  </v-carousel-item>

                  <v-carousel-item>
                    {{ this.energyHeader2 }}
                    <br />
                    <template v-if="this.energy3Text !== ''">
                      {{ this.energy3Text }}:
                      {{ this.energy3Value }}
                      kWh
                    </template>
                    <br />
                    <template v-if="this.energy4Text !== ''">
                      {{ this.energy4Text }}: {{ this.energy4Value }} kWh
                      <br />
                    </template>
                    <template v-else>
                      <br />
                    </template>
                  </v-carousel-item>
                </div>
              </v-carousel>
            </div>
          </v-col>
          <v-col cols="6">
            <vue-svg-gauge class="mini-gauge" :start-angle="-90" :end-angle="90" :value="gaugeValue" :separator-step="0" :min="0" :max="gaugeValueMax" :gauge-color="gaugeColor" :base-color="$vuetify.theme.dark ? '#484848' : '#dddddd'" :scale-interval="0.1">
              <div style="display: flex; justify-content: center; align-items: center; height: 180%">
                <h2>{{ this.powerValue }} kW</h2>
              </div>
            </vue-svg-gauge>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CardTitle from "../cards/CardTitle.vue";

export default {
  name: "CardUnit",
  components: {
    CardTitle,
  },
  props: {
    cardMaxWidth: {
      type: Number,
      default: 600,
      required: false,
    },
    cardName: {
      type: String,
      default: "",
      required: false,
    },
    event: {
      type: Boolean,
      default: false,
      required: false,
    },
    unitName: {
      type: String,
      default: "",
      required: true,
    },
    stateValue: {
      type: String,
      default: "",
      required: false,
    },
    stateText: {
      type: String,
      default: "",
      required: false,
    },
    stateTooltip: {
      type: String,
      default: "",
      required: false,
    },
    stateValue2: {
      type: String,
      default: "",
      required: false,
    },
    stateText2: {
      type: String,
      default: "",
      required: false,
    },
    stateTooltip2: {
      type: String,
      default: "",
      required: false,
    },
    topRightText: {
      type: String,
      default: "",
      required: false,
    },
    topRightValue: {
      type: Number,
      default: 0,
      required: false,
    },
    statusValue: {
      type: String,
      default: "",
      required: false,
    },
    statusText: {
      type: String,
      default: "",
      required: false,
    },
    errorText: {
      type: String,
      default: "",
      required: false,
    },
    errorValue: {
      type: String,
      default: "",
      required: false,
    },
    errorTooltip: {
      type: String,
      default: "",
      required: false,
    },
    powerText: {
      type: String,
      required: false,
    },
    powerValue: {
      type: Number,
      default: 0,
      required: true,
    },
    powerText2: {
      type: String,
      required: false,
    },
    powerValue2: {
      type: Number,
      required: false,
    },
    powerText3: {
      type: String,
      required: false,
    },
    powerValue3: {
      type: Number,
      required: false,
    },
    powerText4: {
      type: Number,
      required: false,
    },
    powerValue4: {
      type: Number,
      required: false,
    },
    energyHeader1: {
      type: String,
      default: "",
      required: false,
    },
    energyHeader2: {
      type: String,
      default: "",
      required: false,
    },
    energy1Text: {
      type: String,
      default: "",
      required: false,
    },
    energy1Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy2Text: {
      type: String,
      default: "",
      required: false,
    },
    energy2Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy3Text: {
      type: String,
      default: "",
      required: false,
    },
    energy3Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy4Text: {
      type: String,
      default: "",
      required: false,
    },
    energy4Value: {
      type: Number,
      default: 0,
      required: false,
    },
    gaugeColor: {
      type: Array,
      required: true,
    },
    gaugeValue: {
      type: Number,
      default: 0,
      required: true,
    },
    gaugeValueMax: {
      type: Number,
      default: 5,
      required: false,
    },
  },
  data() {
    return {
      carousel: 0,
    };
  },
};
</script>

<style scoped>
.mini-gauge {
  max-width: 188px;
}
.v-card {
  min-height: 200px;
}
.v-card--link:before {
  background: none;
}
.v-icon {
  text-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.inner-text {
  height: 100%;
  width: 100%;
}
.span {
  max-width: 200px;
  color: red;
  position: relative;
  top: 50%;
  left: 50%;
}
</style>
